import axios from '../../bootstrap';

/**
 * @param {{ savetype: any; form_type?: string; email_type: string | string[]; content_style?: any; content_edit?: any; content_view?: any; form_attr_id?: string | number | symbol; email_subject?: any; email_id?: any; styleinline?: string; header_custom?: string | number | string[]; css_path?: any[]; header_content_edit?: any; header_content_view?: any; header_style?: any; footer_content_edit?: any; footer_content_view?: any; footer_custom?: string | number | string[]; footer_style?: any; }} JsonData
 */
export function axiosSaveEmail(JsonData) {
    return axios.post('/api/admin/email/update/savemail', JsonData);
}

export function axiosEmailGetCategory() {
    return axios.get('/api/admin/email/category/ajaxgetcategory');
}

/**
 * @param {{ form_type: string; css_style: any; content_edit: string; content_view: string; form_attr_id: string | number ; email_name: string ; email_subject: any; }} JsonData
 */
export function axiosEmailAddForm(JsonData) {
    return axios.post('/api/admin/email/form/addformemail', JsonData);
}

/**
 * @param {{ form_attr_id: number ; }} JsonData
 */
export function axiosEmailDeleteForm(JsonData) {
    return axios.post('/api/admin/email/form/deleteformemail', JsonData);
}

/**
 * @param {{ email_name: string | string[]; }} JsonData
 */
export function axiosEmailAdd(JsonData) {
    return axios.post('/api/admin/email/update/addemail', JsonData);
}

/**
 * @param {{ email_id: number; email_type: string; }} JsonData
 */
export function axiosEmailResetStyle(JsonData) {
    return axios.post('/api/admin/email/reset/style', JsonData);
}
